import { http } from '@/services';

export default {
  getProductList: async function() {
    try {
      return await http.get('residencia/');
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },

  getProductListPublic: async function() {
    try {
      return await http.get('residencia/publico');
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },
  getActiveProductList: async function() {
    try {
      return await http.get(`residencia/status/1`);
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },
  createProduct: async function(product) {
    try {
      return await http.post('residencia/', product);
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },
  editProduct: async function(currentProduct) {
    try {
      return await http.put('residencia/', currentProduct);
    } catch (e) {
      return e.response.data;
    }
  },
  deleteProduct: async function(productId) {
    try {
      return await http.delete(`residencia/${productId}`);
    } catch (e) {
      console.log(e);
      return e.response.data;
    }
  },
};
